import { useState } from 'react'
import { Navbar, Offcanvas } from 'react-bootstrap'
import { HorizontalStack, ShowOnlyOnScreenSize } from '@ztechapps/webui.util'
import { BusyButton } from '@ztechapps/webui.button'
import { usePageLifecycle } from '@ztechapps/common.hook'
import { DbRestoreButton } from '@ztechapps/webui.page'
import { LogoWithName } from '../../view/account/components/LogoWithName'
import { MenuBar } from './MenuBar'
import { Profile } from './Profile'
import { GlobalSearchWrapper } from './GlobalSearchWrapper'
import { MOBILE_BREAKING_POINT } from '../../config/constants'

// Fixed top navbar shell — mirrors apps/panelpunches/admin/src/components/header/index.tsx,
// trimmed to what QuickScore ships (no NotificationBell/QuickCreate/GlobalShortcuts).
export const Header = () => {
  return (
    <Navbar className="header" expand="lg" fixed="top">
      <Navbar.Brand>
        <LogoWithName />
      </Navbar.Brand>

      <ShowOnlyOnScreenSize size="desktop" breakingPoint={MOBILE_BREAKING_POINT}>
        <TopBarContent />
      </ShowOnlyOnScreenSize>

      <ShowOnlyOnScreenSize size="mobile" breakingPoint={MOBILE_BREAKING_POINT}>
        <OffCanvasMenu />
      </ShowOnlyOnScreenSize>
    </Navbar>
  )
}

const OffCanvasMenu = () => {
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  usePageLifecycle(null, handleClose)

  return (
    <div className="me-2">
      <BusyButton icon="bars" onClick={handleShow} />

      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <LogoWithName />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <TopBarContent />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  )
}

const TopBarContent = () => {
  return (
    <>
      <MenuBar />
      {/* ms-auto pushes the search and the trailing Profile group to the right; me-3 keeps a gap. */}
      <div className="ms-auto me-3">
        <GlobalSearchWrapper />
      </div>
      <nav>
        <HorizontalStack gap={2} className="align-items-center">
          <DbRestoreButton />
          <Profile />
        </HorizontalStack>
      </nav>
    </>
  )
}
